/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IPharmacist } from 'app/shared/model/pharmacist.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { IHospitalAssistant } from 'app/shared/model/hospital-assistant.model';

export interface IPersonName {
  id?: string;
  preferred?: boolean | null;
  givenName?: string;
  prefix?: string;
  middleName?: string;
  familyNamePrefix?: string;
  familyName?: string;
  familyNameSufix?: string;
  familyName2?: string;
  active?: boolean;
  created?: dayjs.Dayjs | null;
  microSec?: number;
  timestampentry?: number;
  totalReading?: number;
  lastupdated?: number;
  cursor?: number;
  patient?: IGlucoUser | null;
  doctor?: IDoctor | null;
  pharmacist?: IPharmacist | null;
  diaglabAssistant?: IDiaglabAssistant | null;
  hospitalAssistant?: IHospitalAssistant | null;
}

export const defaultValue: Readonly<IPersonName> = {
  preferred: false,
  active: false,
};
